import Vue from "vue";
import request from "./config/http.js";
import params from "./config/params.js";
import HTTP from "./config/api.js";

let dev = "/tsg-admin";
let dev1 = "/txpy-web";
let dev2 = "/tsg-author";

const apis = {
    refundAuditOrderList(data) {
        //退款审核列表
        return request({
            url: dev + "/sys/order/refundAuditOrderList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updateOrder(data) {
        //订单刷新
        return request({
            url: dev + "/sys/order/updateOrder",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    resetPreposition(data) {
        //订单重置前查询
        return request({
            url: dev + "/sys/order/resetPreposition",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    selectAuditPayStatus(data) {
        //查询结果
        return request({
            url: dev + "/sys/order/selectAuditPayStatus",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updateInvoiceStatus(data) {
        //订单重置前查询
        return request({
            url: dev + "/sys/order/updateInvoiceStatus",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    orderReset(data) {
        //订单重置
        return request({
            url: dev + "/sys/order/reset",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    refundAudit(data) {
        //订单审核
        return request({
            url: dev + "/sys/order/refundAudit",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    closeOrderInfo(data) {
        //订单关闭
        return request({
            url: dev + "/sys/order/closeOrderInfo",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    refundOrder(data) {
        //退款订单
        return request({
            url: dev + "/sys/refund/refundOrder",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    deleteNoticeUrl(data) {
        //删除录用通知书
        return request({
            url: dev + "/sys/articleEmploy/deleteNoticeUrl",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updateNoticeUrl(data) {
        //更新录用通知书
        return request({
            url: dev + "/sys/articleEmploy/updateNoticeUrl",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    savePerodicalAuditInfo(data) {
        //期刊信息保存
        return request({
            url: dev + "/sys/periodical/savePerodicalAuditInfo",
            method: "post",
            data: data,
            // 设置jsonstring 字符串，axios会修改请求编码为application/json
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryPerodicalAuditInfo(data) {
        //查询期刊信息详情
        return request({
            url: dev + "/sys/periodical/queryPerodicalAuditInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    savePeriodicalDatabase(data) {
        //添加收录数据库
        return request({
            url: dev + "/sys/periodical/savePeriodicalDatabase",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryPeriodicalDatabaseById(data) {
        //查询收录数据库
        return request({
            url: dev + "/sys/periodical/queryPeriodicalDatabaseById",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    deletePeriodicalDatabaseById(data) {
        //删除收录数据库
        return request({
            url: dev + "/sys/periodical/deletePeriodicalDatabaseById",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    //期刊设置
    queryAuditFeeNode(data) {
        //运营--查询审核费用节点下拉
        return request({
            url: dev + "/sys/periodical/queryAuditFeeNode",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryPerodicalFeeInfo(data) {
        //费用设置
        return request({
            url: dev + "/sys/periodical/queryPerodicalFeeInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    savePerodicalOtherInfo(data) {
        //期刊设置保存
        return request({
            url: dev + "/sys/periodical/savePerodicalOtherInfo",
            method: "post",
            data: data,
            // 设置jsonstring 字符串，axios会修改请求编码为application/json
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryPerodicalOtherInfo(data) {
        //查询期刊设置详情
        return request({
            url: dev + "/sys/periodical/queryPerodicalOtherInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    savePeriodicalFee(data) {
        //保存费用设置
        return request({
            url: dev + "/sys/periodical/savePeriodicalFee",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryPeriodicalFeeDisInfo(data) {
        return request({
            url: dev + "/sys/periodical/queryPeriodicalFeeDisInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    saveFeeNode(data) {
        //保存审稿费收取环节
        return request({
            url: dev + "/sys/periodical/saveFeeNode",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getFeeNode(data) {
        //审稿费收取环节
        return request({
            url: dev + "/sys/periodical/getFeeNode",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryPeriodicalFeeInfo(data) {
        //查询费用设置
        return request({
            url: dev + "/sys/periodical/queryPeriodicalFeeInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    deletePeriodicalFeeInfo(data) {
        //删除费用设置
        return request({
            url: dev + "/sys/periodical/deletePeriodicalFeeInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // 通知书设置
    // 1. 查询通知书设置 （通知书标题，电子章名称，电子章图片，通知书模板，是否添加作者须知）
    queryNoticeIntroUrl(data) {
        return request({
            url: dev + "/sys/periodical/queryNoticeIntroUrl",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 2.保存通知书模板
    updateNoticeIntroUrl(data) {
        return request({
            url: dev + "/sys/periodical/updateNoticeIntroUrl",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    editingList(data) {
        //自然来稿人列表
        return request({
            url: dev + "/sys/operation/editingList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*栏目管理 不受栏目开关影响*/
    columnList(data) {
        //列表
        return request({
            url: dev + "/sys/column/queryColumnList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    saveColumn(data) {
        //添加信息
        return request({
            url: dev + "/sys/column/saveColumn",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updateColumn(data) {
        //修改信息
        return request({
            url: dev + "/sys/column/updateColumn",
            method: "put",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updateColumnStatus(data) {
        //修改状态
        return request({
            url: dev + "/sys/column/updateColumnStatus",
            method: "put",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    deleteColumn(data) {
        //删除
        return request({
            url: dev + "/sys/column/deleteColumn",
            method: "delete",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*刊期管理 /刊期及三审记录管理*/
    periodList(data) {
        //刊期列表
        return request({
            url: dev + "/sys/periodicalPeriod/periodList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryArticleByPeriod(data) {
        //刊期稿件列表
        return request({
            url: dev + "/sys/periodicalPeriod/queryArticleByPeriod",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    savePeriodInfo(title, data) {
        //添加刊期、修改刊期
        let url =
            title == "添加刊期"
                ? "/sys/periodicalPeriod/savePeriodInfo"
                : "/sys/periodicalPeriod/updatePerod";
        return request({
            url: dev + url,
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    gotoUpdatePerodPage(data) {
        //刊期详情
        return request({
            url: dev + "/sys/periodicalPeriod/gotoUpdatePerodPage",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    //	updatePerod(data) {//修改刊期
    //		return request({
    //			url: dev + "/sys/periodicalPeriod/updatePerod",
    //			method: 'post',
    //			data: data,
    //		}).then((result) => {
    //			return Promise.resolve(result.data)
    //		})
    //	},
    queryPeriodUpdateRecord(data) {
        //稿件撤换记录
        return request({
            url: dev + "/sys/periodicalPeriod/queryPeriodUpdateRecord",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*稿件查询*/
    articleByList(data) {
        //稿件列表
        return request({
            url: dev + "/sys/operation/list",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    listTgr(data) {
        //稿件列表中qq和手机号
        return request({
            url: dev + "/sys/operation/listTgr",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    articlePeriodList(data) {
        //刊期列表
        return request({
            url: dev + "/sys/periodArticleScheduling/periodList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    articleStusList(data) {
        //稿件状态列表
        return request({
            url: dev + "/sys/operation/articleStus",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryTurnks(data) {
        //流程模板列表
        return request({
            url: dev + "/sys/processTurnk/queryTurnks",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取自定义审核项
    getCustomProcess(data) {
        return request({
            url: dev + "/sys/processTurnk/getCustom",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    applyRevocationArticle(data) {
        //稿件状态变更
        return request({
            url: dev + "/sys/operation/applyRevocationArticle",
            method: "post",
            data: data,
            jsonString: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    makeUpFeeDetail(data) {
        //追补订单详情
        return request({
            url: dev + "/sys/operation/makeUpFeeDetail",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    saveMakeUpFee(data) {
        //追补订单提交
        return request({
            url: dev + "/sys/operation/saveMakeUpFee",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    articleDetail(data) {
        //稿件详情
        return request({
            url: dev + "/sys/operation/detail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // v3.0.4稿件详情-查看附件/sys/operation/annexDetail
    articleDetailAnnexsList(data) {
        //稿件详情
        return request({
            url: dev + "/sys/operation/annexDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v3.0.4 稿件审核增加 补充附件，/sys/operation/getAnnexConfig
    manuscriptAnnexDetail(data) {
        //稿件详情
        return request({
            url: dev + "/sys/operation/getAnnexConfig",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // v3.0.4 稿件查询增加 补充附件，/sys/operation/getAnnexConfigNew
    manuscriptAnnexDetailNew(data) {
        //稿件详情
        return request({
            url: dev + "/sys/operation/getAnnexConfigNew",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // v3.0.4 稿件查询增加 补充附件 保存接口 /sys/operation/saveAnnexConfig
    manuscriptAnnexSave(data) {
        // 保存/修改附件设置
        return request({
            url: dev + "/sys/operation/saveAnnexConfig",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v2.8.3 稿件详情页面，修改接口，配合作者端，保留投稿时作者添加顺序
    articleDetailWithAuthorOrdered(data) {
        //稿件详情
        return request({
            url: dev + "/sys/operation/detailTemporarily",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 稿件初审/复审 -审核退修时获取稿件标题和关键字
    articleTitleKw(data) {
        //稿件详情
        return request({
            url: dev + "/sys/operation/getTitleKeyword",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*订单查询*/
    orderList(data) {
        //订单列表
        return request({
            url: dev + "/sys/order/orderList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    orderDetail(data) {
        //订单详情
        return request({
            url: dev + "/sys/order/updOrderDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updOrderInfo(data) {
        //订单状态变更(线上支付)
        return request({
            url: dev + "/sys/order/updOrderInfo",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    orderInfo(data) {
        //订单状态变更(线下支付)
        return request({
            url: dev + "/sys/order/orderInfo",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    auditOrderInfo(data) {
        //订单状态变更审核
        return request({
            url: dev + "/sys/order/auditOrderInfo",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    discountApply(data) {
        //订单优惠申请
        return request({
            url: dev + "/sys/order/discountApply",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*订单优惠审核*/
    discountList(data) {
        //订单优惠审核列表
        return request({
            url: dev + "/sys/order/discountList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    discountDetail(data) {
        //订单优惠详情
        return request({
            url: dev + "/sys/order/discountDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 1个订单多个申请，新订单审核完成页面查看订单详情接口
    discountAuditDetail(data) {
        //订单优惠详情
        return request({
            url: dev + "/sys/order/discountAuditDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    discountAudit(data) {
        //订单优惠审核
        return request({
            url: dev + "/sys/order/discountAudit",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*专家管理*/
    listExpert(data) {
        //外审列表
        return request({
            url: dev + "/sys/user/listExpert",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    addExpert(flag, data) {
        //添加专家账号
        let url = flag == 1 ? "/sys/user/addExpert" : "/sys/user/updExpert";
        return request({
            url: dev + url,
            method: "post",
            data: data,
            jsonString: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    addExpertDetail(flag, data) {
        //保存专家信息
        let url = flag == 1 ? "/sys/user/addExpertDetail" : "/sys/user/updExpert";
        return request({
            url: dev + url,
            method: "post",
            data: data,
            jsonString: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    selExpertDetail(data) {
        //专家信息回显
        return request({
            url: dev + "/sys/user/selExpertDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    treeList(data) {
        //学科树结构
        return request({
            url: dev1 + "/subject/treeList",
            method: "get",
            params: data,
            isToken: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    subjectList(data) {
        //研究方向一级
        return request({
            // url: '/api/zw-public/researchField/getOneList',
            url: "/api/zw-public/researchField/getRelationList",
            // url:"/tsg-admin/sys/perSubject/list",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // v3.0.1 学科领域查询投审稿数据
    tsgSubjectList(params) {
        return request({
            // 受开关影响
            url: "/tsg-admin/sys/perSubject/list",
            method: "get",
            params,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    tsgAllSubjectList(params) {
        return request({
            // 不受开关影响 的学科领域列表
            url: "/tsg-admin/sys/perSubject/allList",
            method: "get",
            params,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v3.0.1 删除专家
    delExpert(data) {
        return request({
            url: "/tsg-admin/sys/user/delExpert",
            method: "delete",
            data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getTwoList(data) {
        //研究方向二级
        return request({
            url: "/api/zw-public/researchField/getTwoList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getThreeList(data) {
        //研究方向三级
        return request({
            url: "/api/zw-public/researchField/getThreeList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    titleList(data) {
        //职称列表一级
        return request({
            // url: "/api/zw-public/title/getOneList",
            url: "/api/zw-public/title/getTitleList",
            method: "get",
            params: data,
            isToken: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    titleTwoList(data) {
        //职称列表二级
        return request({
            url: "/api/zw-public/title/getTwoList",
            method: "get",
            params: data,
            isToken: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    titleThreeList(data) {
        //职称列表三级
        return request({
            url: "/api/zw-public/title/getThreeList",
            method: "get",
            params: data,
            isToken: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getEduDictionary(data) {
        
        //学历
        return request({
            url: "/api/zw-public/code/getEduDictionary",
            method: "post",
            data: data,
            isToken: true,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    /*作者管理*/
    findAuthors(data) {
        //投稿人列表
        return request({
            url: dev + "/sys/sso/findAuthors",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    authorPage(data) {
        //作者信息列表
        return request({
            url: dev + "/sys/sso/authorPage",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getBlacklistMobile(data) {
        //投稿人列表
        return request({
            url: dev + "/sys/sso/getBlacklistMobile",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getEditorList(data) {
        //采编列表(转接采编)
        return request({
            url: dev + "/sys/Editing/editorList",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    //调整采编采编列表
    editorIdList(data) {
        return request({
            url: dev + "/sys/Editing/editorIdList",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    //调整采编采编列表
    reviewEditList(data) {
        return request({
            url: dev + "/sys/Editing/reviewEditList",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    //调整采编
    updateEditingId(data) {
        return request({
            url: dev + "/sys/Editing/updateEditingId",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    assignEditor(data) {
        //指定采编
        return request({
            url: dev + "/sys/sso/assignEditor",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*采编绩效*/
    queryPerformanceList(data) {
        //作者列表
        return request({
            url: dev + "/sys/reviewerPerformance/queryPerformanceList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    authorList(data) {
        //初审编辑列表
        return request({
            url: dev + "/sys/operation/authorList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryReviewUserByArticle(data) {
        //采编列表
        return request({
            url: dev + "/sys/reviewerPerformance/queryReviewUserByArticle",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // v2.9.5 绩效管理-审稿绩效--------start
    // 1.审稿绩效列表 /sys/articleProofread/articleProofreadSum 绩效稿件统计
    articlePerformanceStatistic(data) {
        return request({
            url: dev + "/sys/articleProofread/articleProofreadSum",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 2.导出汇总表Excel /sys/articleProofread/exportArticleProofread
    exportArticlePerformanceSummarize(data) {
        return request({
            url: dev + "/sys/articleProofread/exportArticleProofread",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 3.导出详情表Excel /sys/articleProofread/exportDetailProofread
    exportArticlePerformanceDetail(data) {
        return request({
            url: dev + "/sys/articleProofread/exportDetailProofread",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 4.稿件明细查询 /sys/articleProofread/queryDetailList
    articlePerformanceDetail(data) {
        return request({
            url: dev + "/sys/articleProofread/queryDetailList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v2.9.5 绩效管理-审稿绩效--------end

    // v3.0.1 绩效管理/校对绩效 -----------start
    // /sys/proofread/proofreadSum 校对绩效统计列表(月)
    proofreadSum(data) {
        return request({
            url: dev + "/sys/proofread/proofreadSum",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v3.0.1 绩效管理/校对绩效 -----------end

    /*采编名片管理*/
    cardList(data) {
        //采编列表
        return request({
            url: dev + "/sys/Editing/cardList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    updCard(data) {
        //修改
        return request({
            url: dev + "/sys/Editing/updCard",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    /*录用退稿、录用退修*/
    queryArticleRevokeList(data) {
        //退稿、退修列表
        return request({
            url: dev + "/sys/articleRevoke/queryArticleRevokeList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    gotoRevocationArticlePage(data) {
        //退稿、退修详情(未审核前)
        return request({
            url: dev + "/sys/articleRevoke/gotoRevocationArticlePage",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    revocationArticleFinshInfo(data) {
        //退稿、退修详情(审核后、查看)
        return request({
            url: dev + "/sys/articleRevoke/selectRevocationArticleFinshInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // auditPass(status, data) {//退稿 status:1通过，2退回  上个版本接口，退稿时直接退款
    // 	let url = status == 1 ? '/sys/articleRevoke/auditPass' : '/sys/articleRevoke/rejectRevocationArticle';
    // 	return request({
    // 		url: dev + url,
    // 		method: 'get',
    // 		params: data,
    // 	}).then((result) => {
    // 		return Promise.resolve(result.data)
    // 	})
    // },
    auditPass(status, data) {
        //退稿 status:1通过，2退回  新版本退稿时不退款，用户自己单独申请退款
        let url =
            status == 1
                ? "/sys/articleRevoke/articlePass"
                : "/sys/articleRevoke/rejectRevocationArticle";
        return request({
            url: dev + url,
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    auditReturnPass(status, data) {
        //退修 status:1通过，2退回
        let url =
            status == 1
                ? "/sys/articleRevoke/auditReturnPass"
                : "/sys/articleRevoke/rejectRevocationArticle";
        return request({
            url: dev + url,
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    sendVerifyCode(data) {
        //发送验证码
        return request({
            url: dev + "/sys/articleRevoke/sendVerifyCode",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    sendAliyunVerifyCode(data) {
        //发送验证码2
        return request({
            url: dev + "/sys/articleRevoke/sendAliyunVerifyCode",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    verifyCode(data) {
        //校验验证码
        return request({
            url: dev + "/sys/articleRevoke/verifyCode",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    aliyunVerifyCode(data) {
        //校验验证码2
        return request({
            url: dev + "/sys/articleRevoke/aliyunVerifyCode",
            method: "post",
            data: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 2022/10/13 三审
    thirdReviewRecord(data) {
        return request({
            url: dev + "/sys/Editing/thirdReviewRecord",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    haveScreeningAndExpert(data) {
        return request({
            url: dev + "/sys/Editing/haveScreeningAndExpert",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getAuditInfoList(data) {
        return request({
            url: dev + "/sys/expertAudit/getAuditInfoList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    saveRecordConfig(data) {
        return request({
            url: dev + "/sys/Editing/saveRecordConfig",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getRecordConfig(data) {
        return request({
            url: dev + "/sys/Editing/getRecordConfig",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // v2.7.2 专家绩效相关接口
    // 专家绩效列表接口
    expertPerformanceList(data) {
        return request({
            url: dev + "/sys/performance/page",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 审稿明细 /sys/performance/detailed
    expertAuditDetails(data) {
        return request({
            url: dev + "/sys/performance/detailed",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v2.7.2 专家绩效相关接口-end

    // v2.8.3
    // 邮件模板选项列表
    getOptionList(data) {
        return request({
            url: dev + "/sys/email/getOptionList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 邮件类型列表
    getTypeList(data) {
        return request({
            url: dev + "/sys/email/getTypeList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 查看邮件模板
    getTemplate(data) {
        return request({
            url: dev + "/sys/email/get",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 查看邮件模板
    getImg(data) {
        return request({
            url: dev + "/sys/email/getImg",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 查看邮件模板
    getImg(data) {
        return request({
            url: dev + "/sys/email/getImg",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 保存/修改邮件模板
    saveEmali(data) {
        return request({
            url: dev + "/sys/email/save",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 保存/修改邮件模板
    uploadEmaliImg(data) {
        return request({
            url: dev + "/sys/email/upload",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 保存/修改邮件模板
    saveConfig(data) {
        return request({
            url: dev + "/sys/email/saveConfig",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 保存/修改投稿设置
    saveSubmission(data) {
        return request({
            url: dev + "/sys/contribute/save",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 查看投稿设置
    getSubmission(data) {
        return request({
            url: dev + "/sys/contribute/get",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取期刊通知配置信息-3.0.7
    perNoticeInfo(data) {
        return request({
            url: dev + "/sys/perNotice/getInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 保存/修改期刊通知配置信息-3.0.7
    savePerNotice(data) {
        return request({
            url: dev + "/sys/perNotice/save",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 查看注册设置
    getRegister(data) {
        return request({
            url: dev + "/sys/contribute/getRegister",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 保存/修改广告
    saveAd(data) {
        return request({
            url: dev + "/sys/contribute/saveAd",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 投稿完成页广告列表
    getList(data) {
        return request({
            url: dev + "/sys/contribute/getList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 关闭/开启广告
    updStatus(data) {
        return request({
            url: dev + "/sys/contribute/updStatus",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 投稿完成页广告列表
    delAd(data) {
        return request({
            url: dev + "/sys/contribute/delAd",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取作者信息
    findAuthorByPhoneAndName(data) {
        return request({
            url: dev + "/sys/articleRevoke/findAuthorByPhoneAndName",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取作者信息
    findAuthorByAuthorId(data) {
        return request({
            url: dev + "/sys/articleRevoke/findAuthorByAuthorId",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取作者信息
    getRelationType(data) {
        return request({
            url: dev + "/sys/articleRevoke/getRelationType",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 审核保存
    saveAuditPass(data) {
        return request({
            url: dev + "/sys/articleRevoke/saveAuditPass",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 修改稿件信息保存
    updateArticleRepai(data) {
        return request({
            url: dev + "/sys/articleEmploy/updateArticleRepair",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 审核详情
    revokeArticleDetail(data) {
        return request({
            url: dev + "/sys/articleRevoke/revokeArticleDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 修改详情
    queryArticleDetail(data) {
        return request({
            url: dev + "/sys/articleEmploy/queryArticleDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    //
    revokeArticleAuthorInfoDetail(data) {
        return request({
            url: dev + "/sys/articleRevoke/revokeArticleAuthorInfoDetail",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取补充作者信息
    authorSupply(data) {
        return request({
            url: dev + "/sys/supplement/get",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 修改补充作者信息
    updAuthorSupply(data) {
        return request({
            url: dev + "/sys/supplement/upd",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取补充作者信息开关状态
    getOpen(data) {
        return request({
            url: dev + "/sys/supplement/getOpen",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 获取强制补充作者信息开关
    getForceOpen(data) {
        return request({
            url: dev + "/sys/supplement/getForceOpen",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 补充作者信息开关
    switchChange(data) {
        return request({
            url: dev + "/sys/supplement/open",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 初审获取作者列表
    getAuthorList(data) {
        return request({
            url: dev + "/sys/supplement/getAuthorList",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 是否有修改稿件按钮
    processSetOpen(data) {
        return request({
            url: dev + "/sys/articleEmploy/processSetOpen",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 初审获取作者列表
    getAuthorInfo(data) {
        return request({
            url: dev + "/sys/supplement/getAuthorInfo",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 初审保存作者信息
    saveAuthorInfo(data) {
        return request({
            url: dev + "/sys/supplement/saveAuthorInfo",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    upCheckReportType(data) {
        //保存作者查重报告设置节点
        return request({
            url: dev + "/sys/periodical/upCheckReportType",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    queryCheckReportType(data) {
        //查询作者查重报告设置节点
        return request({
            url: dev + "/sys/periodical/queryCheckReportType",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getAssignPersonnels(data) {
        //获取初、复、终审分配人员列表
        return request({
            url: dev + "/sys/auditConfig/getAssignPersonnels",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    auditConfigGetOpen(data) {
        //获取初、复、终审开关
        return request({
            url: dev + "/sys/auditConfig/getOpen",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getZsButton(data) {
        //获取是否包含终审分配配置按钮
        return request({
            url: dev + "/sys/auditConfig/getZsButton",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    auditConfigOpen(data) {
        // 初、复、终审开关打开/关闭
        return request({
            url: dev + "/sys/auditConfig/open",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getAuditsByAssign(data) {
        //根据分配人员获取初、复、终审审核人员列表
        return request({
            url: dev + "/sys/auditConfig/getAuditsByAssign",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    getAudits(data) {
        //根据分配人员获取初、复、终审审核人员列表
        return request({
            url: dev + "/sys/auditConfig/getAudits",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    auditConfigSave(data) {
        // 初、复、终审开关打开/关闭
        return request({
            url: dev + "/sys/auditConfig/save",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    upRefundAuditSwitch(data) {
        // 审核设置开关
        return request({
            url: dev + "/sys/periodical/upRefundAuditSwitch",
            method: "get",
            data: data,
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    periodicalManagementAudit(data) {
        // 审核设置配置
        return request({
            url: dev + "/sys/periodical/periodicalManagementAudit",
            method: "get",
            data: data,
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

    // v3.0.3 专家启用或关闭 toggleExpertStatus
    toggleExpertFlag(params) {
        // 审核设置配置
        return request({
            url: dev + "/sys/user/toggleExpertStatus",
            method: "get",

            params,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },

  // v3.0.3 专家启用或关闭 toggleExpertStatus
  toggleExpertFlag(params) {
    // 审核设置配置
    return request({
      url: dev + "/sys/user/toggleExpertStatus",
      method: "get",

      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // start --- v3.0.4 期刊信息管理/投稿设置/附件设置
  // 1. /sys/annx/getSelect 拦截节点下拉列表
  blockedNodeList(params) {
    return request({
      url: dev + "/sys/annx/getSelect",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 2. /sys/annx/saveInterceptNode 保存拦截节点
  saveblockedNode(params) {
    // 保存拦截节点
    return request({
      url: dev + "/sys/annx/saveInterceptNode",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3. /sys/annx/list 附件模板列表
  annexsTemplateList(params) {
    // 审核设置配置
    return request({
      url: dev + "/sys/annx/allList",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 4. /sys/annx/save 保存/修改附件设置
  saveAnnexTemplate(data) {
    // 保存/修改附件设置
    return request({
      url: dev + "/sys/annx/save",
      method: "post",
      data: data,
      jsonString: JSON.stringify(data),
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 5. /sys/annx/del 删除附件
  delAnnexTemplat(params) {
    return request({
      url: dev + "/sys/annx/del",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 6. /sys/annx/detail 获取附件详细信息
  annexTemplatDetail(params) {
    return request({
      url: dev + "/sys/annx/detail",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /* --完成页弹窗相关 ---*/
  // 7. /sys/annx/popupDetail 获取完成页弹窗详细信息
  completedModalDetail(params){
    return request({
      url: dev + "/sys/annx/popupDetail",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 8. /sys/annx/savePopup保存/修改完成页弹窗
  saveCompletedModal(data) {
    // 保存/修改附件设置
    return request({
      url: dev + "/sys/annx/savePopup",
      method: "post",
      data: data,
      jsonString: JSON.stringify(data),
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },

  // end --- v3.0.4 期刊信息管理/投稿设置/附件设置

   // start --- v3.0.4 刊期及审核记录管理 补充附件
  // 1. /sys/periodicalPeriod/getAnnexConfig 单个补充附件页面数据
  periodAnnexConfig(params) {
    return request({
      url: dev + "/sys/periodicalPeriod/getAnnexConfig",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
   // 2. /sys/periodicalPeriod/saveAnnexConfig 单个补充附件 保存
   singlePeriodAnnexSave(data) {
    // 保存/修改附件设置
    return request({
      url: dev + "/sys/periodicalPeriod/saveAnnexConfig",
      method: "post",
      data: data,
      jsonString: JSON.stringify(data),
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  /* start----v3.0.5 稿件评分*/
  // 1. /sys/scoreConfig/getScoreSwitch 稿件评分开关详情-3.0.5 
  scoreSettingStatus(params) {
    return request({
      url: dev + "/sys/scoreConfig/getScoreSwitch",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
 
  // 2./sys/scoreConfig/getConfig 获取分数设置及规则设置-3.0.5
  scoreSettingConfig(params) {
    return request({
      url: dev + "/sys/scoreConfig/getConfig",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 3. /sys/scoreConfig/saveConfig 保存分数设置及规则设置-3.0.5
  saveScoreSettingConfig(data) {
    // 保存/修改附件设置
    return request({
      url: dev + "/sys/scoreConfig/saveConfig",
      method: "post",
      data: data,
      jsonString: JSON.stringify(data),
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 4./sys/scoreConfig/closeSwitch 关闭稿件评分开关-3.0.5
  closeScoreSetting(params) {
    return request({
      url: dev + "/sys/scoreConfig/closeSwitch",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 5./sys/scoreConfig/getSwitch 稿件审核时获取评分是否开启和评分是否必填-3.0.5
  auditScoreStatus(params) {
    return request({
      url: dev + "/sys/scoreConfig/getSwitch",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 6. /sys/scoreConfig/getAuditScoreDetail稿件审核评分页详情-3.0.5
  getAuditScoreDetail(params) {
    return request({
      url: dev + "/sys/scoreConfig/getAuditScoreDetail",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
  },
  // 7. /sys/scoreConfig/lyScoreDetail录用审核时的评分详情-3.0.5
  lyScoreDetail(params) {
    return request({
      url: dev + "/sys/scoreConfig/lyScoreDetail",
      method: "get",
      params,
    }).then((result) => {
      return Promise.resolve(result.data);
    });
    },
    // 8.  /sys/scoreConfig/artScoreDetail稿件详情页的评分详情-3.0.5
    artScoreDetail(params) {
        return request({
          url: dev + "/sys/scoreConfig/artScoreDetail",
          method: "get",
          params,
        }).then((result) => {
          return Promise.resolve(result.data);
        });
    },
    // 9. /sys/scoreConfig/getScoreDetailByRecordId 详情页根据审核记录id获取稿件评分详情-3.0.5
    getScoreDetailByRecordId(params) {
        return request({
          url: dev + "/sys/scoreConfig/getScoreDetailByRecordId",
          method: "get",
          params,
        }).then((result) => {
          return Promise.resolve(result.data);
        });
    },
   /* end----v3.0.5 稿件评分*/


    // start --- v3.0.5 刊期及审核记录管理 补充附件
    // 1. /sys/periodicalPeriod/getAnnexConfig 单个补充附件页面数据
    periodAnnexConfig(params) {
        return request({
            url: dev + "/sys/periodicalPeriod/getAnnexConfig",
            method: "get",
            params,
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 2. /sys/periodicalPeriod/saveAnnexConfig 单个补充附件 保存
    singlePeriodAnnexSave(data) {
        // 保存/修改附件设置
        return request({
            url: dev + "/sys/periodicalPeriod/saveAnnexConfig",
            method: "post",
            data: data,
            jsonString: JSON.stringify(data),
        }).then((result) => {
            return Promise.resolve(result.data);
        });
    },
    // 自定义登录配置查询
    queryCustomLoginConfig(data) {
        return request({
            url: dev + "/sys/periodicalLogin/queryPeriodicalLoginAuditInfo",
            method: "get",
            params: data,
        });
    },
    // 开启/关闭自定义登录
    updateCustomLoginConfigStatus(data) {
        return request({
            url: dev + "/sys/periodicalLogin/open",
            method: "get",
            params: data,
        });
    },
    // 提交自定义登录配置
    submitCustomLoginConfig(data) {
        return request({
            url: dev + "/sys/periodicalLogin/periodicalLoginSubmit",
            method: "post",
            data,
            jsonString: JSON.stringify(data),
        });
    },
    // /sys/found/discountAuditCancel 3.0.6基金优惠审核-取消优惠
    discountAuditCancel(data) {
        return request({
            url: dev + "/sys/found/discountAuditCancel",
            method: "get",
            params: data,
        }).then((result) => {
            return Promise.resolve(result.data);
          });;
    },
};

export default apis;



// WEBPACK FOOTER //
// ./src/core/api/operation.serve.js